// frontend/src/components/GroupDeleteModal.jsx

import React, { useEffect, useRef } from 'react';
import { useTranslation } from '../i18n';

export default function GroupDeleteModal({ group, onClose, onConfirm }) {
  const { _ } = useTranslation();
  const cancelButtonRef = useRef(null);

  // Enfocar botón Cancelar al abrir el modal
  useEffect(() => {
    if (cancelButtonRef.current) cancelButtonRef.current.focus();
  }, []);

  // Cerrar con tecla ESC
  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  if (!group) return null;

  const handleDelete = () => {
    onConfirm(group.id);
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        onClick={(e) => e.stopPropagation()} // evita que clic en contenido cierre modal
      >
        <h2 id="modal-title" className="modal-title">
          {_('Confirm Deletion')}
        </h2>
        <p className="my-4">
          {_('Are you sure you want to permanently delete the group')}
          <strong className="mx-1">"{group.group_name}"</strong>?
        </p>
        <p className="text-sm text-red-500">
          {_('This action is irreversible and will delete all its members and invitations.')}
        </p>

        <div className="form-actions mt-6">
          <button
            type="button"
            className="button-secondary"
            onClick={onClose}
            ref={cancelButtonRef}
          >
            {_('Cancel')}
          </button>
          <button
            type="button"
            className="button-primary bg-red-600 hover:bg-red-700"
            onClick={handleDelete}
          >
            {_('Yes, Delete')}
          </button>
        </div>
      </div>
    </div>
  );
}
